import { useQuery } from '@tanstack/react-query';
import type {
  ActivationsDto,
  AgentsDataRow,
  InactiveReasonRow,
  MasterAgentRow,
  QuickStatsDto,
  SalesDataRow,
  StateSubscribersRow,
} from '@app/shared';
import { api } from '../../lib/api';

/** Every widget loads only when the user asks for it, as on the reference. */

export const useQuickStats = (enabled: boolean) =>
  useQuery({
    queryKey: ['dashboard', 'quick-stats'],
    queryFn: () => api.get<QuickStatsDto>('/dashboard/quick-stats'),
    enabled,
  });

export const useActivations = (enabled: boolean) =>
  useQuery({
    queryKey: ['dashboard', 'activations'],
    queryFn: () => api.get<ActivationsDto>('/dashboard/activations'),
    enabled,
  });

const useRows = <T>(key: string, enabled: boolean) =>
  useQuery({
    queryKey: ['dashboard', key],
    queryFn: () => api.get<{ data: T[] }>(`/dashboard/${key}`),
    select: (r) => r.data,
    enabled,
  });

export const useSubscribersByState = (enabled: boolean) =>
  useRows<StateSubscribersRow>('subscribers-by-state', enabled);
export const useByMasterAgent = (enabled: boolean) =>
  useRows<MasterAgentRow>('by-master-agent', enabled);
export const useInactiveByReason = (enabled: boolean) =>
  useRows<InactiveReasonRow>('inactive-by-reason', enabled);
export const useSalesData = (enabled: boolean) => useRows<SalesDataRow>('sales', enabled);
export const useAgentsData = (enabled: boolean) => useRows<AgentsDataRow>('agents', enabled);
